export default function Oferta() {
  return (
    <div>
      <h1>OFERTA</h1>
      <h1>Strona w przebudowie - zapraszamy w krótce</h1>
    </div>
  );
}
